import { render, staticRenderFns } from "./EmployeesPage.vue?vue&type=template&id=a9606560&scoped=true"
import script from "./EmployeesPage.vue?vue&type=script&lang=js"
export * from "./EmployeesPage.vue?vue&type=script&lang=js"
import style0 from "./EmployeesPage.vue?vue&type=style&index=0&id=a9606560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9606560",
  null
  
)

export default component.exports